export default __webpack_public_path__ + "static/PEPETTE-abd1f8b679a98ff4cdc83cc7535af627.png";